import * as SwitchPrimitive from '@radix-ui/react-switch';
import styled from 'styled-components';

export const SwitchPrimitiveRoot = styled(SwitchPrimitive.Root)`
  all: unset;
  width: 42px;
  height: 25px;
  background-color: #DEDEDE;
  border-radius: 9999px;
  position: relative;
  box-shadow: 0 1px 5px #7C7C7C;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  border: 1px solid;
  border-color: ${(props) => props.theme.colors.primary};

  &:focus {
    box-shadow: 0 0 0 2px black;
  }

  &[data-state='checked'] {
    background-color: #042647;
  }
`;

export const SwitchPrimitiveThumb = styled(SwitchPrimitive.Thumb)`
  display: block;
  width: 21px;
  height: 21px;
  background-color: white;
  border-radius: 9999px;
  box-shadow: 0 1px 1px #7C7C7C;
  transition: transform 100ms;
  transform: translateX(2px);
  will-change: transform;

  &[data-state='checked'] {
    transform: translateX(19px);
  }
`;

export const SwitchContent = styled.div`
  width: 20px;
  height: 21px;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* border: 1px solid; */
  /* border-color: transparent; */
`;
